import { Empty, notification } from 'antd';

import {
  UserInfo,
  UserStatus,
} from '../pages/Registration/Registration.interfaces';
import { Country, DocumentTemplate } from '../store/api/types.api';
import { NOTIFICATION_DEFAULT_DURATION_IN_SECONDS } from './constants';
import { NotificationTypes, Select } from './interfaces';

const close = (): void => {
  // eslint-disable-next-line no-console
  console.log(
    'Notification was closed. Either the close button was clicked or duration time elapsed.',
  );
};

export const openNotification = (
  type: NotificationTypes,
  message: string,
  durationInSeconds?: number,
): void => {
  const key = `open${Date.now()}`;

  notification[type]({
    message: message,
    key,
    onClose: close,
    duration: durationInSeconds ?? NOTIFICATION_DEFAULT_DURATION_IN_SECONDS,
  });
};

export const getTemplate = (documents: DocumentTemplate[]): Select[] => {
  // Не все документы имеют шаблон, только те, у которых есть fileId
  return documents
    .filter((doc) => doc.fileId !== '')
    .map((el) => ({
      value: el.fileId,
      label: el.name,
    }));
};

export const getRequiredDocSelect = (
  documents: DocumentTemplate[],
): Select[] => {
  // Select для выбора типа документа при создании нового документа
  return documents.map((el) => ({
    value: el.id,
    label: el.name,
  }));
};

export const checkRegistrationAvailable = (
  userInfo: UserInfo | null,
): boolean => {
  return (
    userInfo?.status === UserStatus.REGISTRATION ||
    userInfo?.status === UserStatus.CONFIRMATION ||
    userInfo?.status === UserStatus.IN_SURVEY ||
    userInfo?.status === UserStatus.SIGN_CONTRACT
  );
};

export const checkDateIsValid = (dateString: string): boolean => {
  if (!dateString || dateString === '0001-01-01T00:00:00+00:00') return false;
  return true;
};

export const formatCurrency = (value: number, symbol?: string): string => {
  const digitToBeSeparatedRegexp = /(\d)(?=(\d{3})+([^\d]|$))/g;

  return (
    String(Number(value).toFixed(2)).replace(digitToBeSeparatedRegexp, '$1 ') +
    (symbol ? ` ${symbol}` : '')
  );
};
